var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQrCode(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 151,
    viewBox: "0 0 151 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_1014)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.999 0H-0.000671387V151H150.999V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0429 8.99951H11.9597V14.0827H17.0429V8.99951Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1261 8.99951H17.0429V14.0827H22.1261V8.99951Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2092 8.99951H22.1261V14.0827H27.2092V8.99951Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2924 8.99951H27.2092V14.0827H32.2924V8.99951Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3756 8.99951H32.2924V14.0827H37.3756V8.99951Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4587 8.99951H37.3756V14.0827H42.4587V8.99951Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5419 8.99951H42.4587V14.0827H47.5419V8.99951Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7082 8.99951H52.6251V14.0827H57.7082V8.99951Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2072 8.99951H83.1241V14.0827H88.2072V8.99951Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3736 8.99951H93.2904V14.0827H98.3736V8.99951Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.54 8.99951H103.457V14.0827H108.54V8.99951Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.623 8.99951H108.54V14.0827H113.623V8.99951Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.706 8.99951H113.623V14.0827H118.706V8.99951Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.789 8.99951H118.706V14.0827H123.789V8.99951Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.873 8.99951H123.789V14.0827H128.873V8.99951Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.956 8.99951H128.873V14.0827H133.956V8.99951Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.039 8.99951H133.956V14.0827H139.039V8.99951Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0429 14.0827H11.9597V19.1658H17.0429V14.0827Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5419 14.0827H42.4587L42.4587 19.1658H47.5419V14.0827Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8746 14.0827H62.7914V19.1658H67.8746V14.0827Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9577 14.0827H67.8746V19.1658H72.9577V14.0827Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1241 14.0827H78.0409V19.1658H83.1241V14.0827Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2072 14.0827H83.1241V19.1658H88.2072V14.0827Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3736 14.0827H93.2904V19.1658H98.3736V14.0827Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.54 14.0827H103.457V19.1658H108.54V14.0827Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.039 14.0827H133.956V19.1658H139.039V14.0827Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0429 19.1658H11.9597V24.249H17.0429V19.1658Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2092 19.1658H22.1261V24.249H27.2092V19.1658Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2924 19.1658H27.2092V24.249H32.2924V19.1658Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3756 19.1658H32.2924V24.249H37.3756V19.1658Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5419 19.1658H42.4587V24.249H47.5419V19.1658Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7082 19.1658H52.6251V24.249H57.7082V19.1658Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7914 19.1658H57.7082V24.249H62.7914V19.1658Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1241 19.1658H78.0409V24.249H83.1241V19.1658Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3736 19.1658H93.2904V24.249H98.3736V19.1658Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.54 19.1658H103.457V24.249H108.54V19.1658Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.706 19.1658H113.623V24.249H118.706V19.1658Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.789 19.1658H118.706V24.249H123.789V19.1658Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.873 19.1658H123.789V24.249H128.873V19.1658Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.039 19.1658H133.956V24.249H139.039V19.1658Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0429 24.249H11.9597V29.3322H17.0429V24.249Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2092 24.249H22.1261V29.3322H27.2092V24.249Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2924 24.249H27.2092V29.3322H32.2924V24.249Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3756 24.249H32.2924V29.3322H37.3756V24.249Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5419 24.249H42.4587V29.3322H47.5419V24.249Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7914 24.249H57.7082V29.3322H62.7914V24.249Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8746 24.249H62.7914V29.3322H67.8746V24.249Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9577 24.249H67.8746V29.3322H72.9577V24.249Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1241 24.249H78.0409V29.3322H83.1241V24.249Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2904 24.249H88.2073V29.3322H93.2904V24.249Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3736 24.249H93.2904V29.3322H98.3736V24.249Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.54 24.249H103.457V29.3322H108.54V24.249Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.706 24.249H113.623V29.3322H118.706V24.249Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.789 24.249H118.706V29.3322H123.789V24.249Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.873 24.249H123.789V29.3322H128.873V24.249Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.039 24.249H133.956V29.3322H139.039V24.249Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0429 29.3322H11.9597V34.4154H17.0429V29.3322Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2092 29.3322H22.1261V34.4154H27.2092V29.3322Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2924 29.3322H27.2092V34.4154H32.2924V29.3322Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3756 29.3322H32.2924V34.4154H37.3756V29.3322Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5419 29.3322H42.4587V34.4154H47.5419V29.3322Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7914 29.3322H57.7082V34.4154H62.7914V29.3322Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1241 29.3322H78.0409V34.4154H83.1241V29.3322Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3736 29.3322H93.2904V34.4154H98.3736V29.3322Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.54 29.3322H103.457V34.4154H108.54V29.3322Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.706 29.3322H113.623V34.4154H118.706V29.3322Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.789 29.3322H118.706V34.4154H123.789V29.3322Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.873 29.3322H123.789V34.4154H128.873V29.3322Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.039 29.3322H133.956V34.4154H139.039V29.3322Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0429 34.4154H11.9597V39.4985H17.0429V34.4154Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5419 34.4154H42.4587V39.4985H47.5419V34.4154Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8746 34.4154H62.7914V39.4985H67.8746V34.4154Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2072 34.4154H83.1241V39.4985H88.2072V34.4154Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2904 34.4154H88.2072V39.4985H93.2904V34.4154Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.54 34.4154H103.457V39.4985H108.54V34.4154Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.039 34.4154H133.956V39.4985H139.039V34.4154Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0429 39.4985H11.9597V44.5817H17.0429V39.4985Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1261 39.4985L17.0429 39.4985V44.5817H22.1261V39.4985Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2092 39.4985H22.1261V44.5817H27.2092V39.4985Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2924 39.4985H27.2092V44.5817H32.2924V39.4985Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3756 39.4985H32.2924V44.5817H37.3756V39.4985Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4587 39.4985L37.3756 39.4985V44.5817H42.4587L42.4587 39.4985Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5419 39.4985H42.4587L42.4587 44.5817H47.5419V39.4985Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7082 39.4985H52.6251V44.5817H57.7082V39.4985Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8746 39.4985H62.7914V44.5817H67.8746V39.4985Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0409 39.4985H72.9577V44.5817H78.0409V39.4985Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2072 39.4985H83.1241V44.5817H88.2072V39.4985Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3736 39.4985L93.2904 39.4985V44.5817H98.3736V39.4985Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.54 39.4985H103.457V44.5817H108.54V39.4985Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.623 39.4985L108.54 39.4985V44.5817H113.623V39.4985Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.706 39.4985H113.623V44.5817H118.706V39.4985Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.789 39.4985H118.706V44.5817H123.789V39.4985Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.873 39.4985H123.789V44.5817H128.873V39.4985Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.956 39.4985L128.873 39.4985V44.5817H133.956V39.4985Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.039 39.4985H133.956V44.5817H139.039V39.4985Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7082 44.5817H52.6251V49.6649H57.7082V44.5817Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8746 44.5817H62.7914V49.6649H67.8746V44.5817Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1241 44.5817H78.0409V49.6649H83.1241V44.5817Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2904 44.5817H88.2072L88.2073 49.6649H93.2904V44.5817Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0429 49.6649H11.9597V54.748H17.0429V49.6649Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2092 49.6649H22.1261V54.748H27.2092V49.6649Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4587 49.6649H37.3756V54.748H42.4587V49.6649Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5419 49.6649H42.4587V54.748H47.5419V49.6649Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7914 49.6649H57.7082V54.748H62.7914V49.6649Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8746 49.6649H62.7914V54.748H67.8746V49.6649Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2073 49.6649H83.1241V54.748H88.2072L88.2073 49.6649Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.457 49.6649H98.3736V54.748H103.457V49.6649Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.54 49.6649H103.457V54.748H108.54V49.6649Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.873 49.6649H123.789V54.748H128.873V49.6649Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.039 49.6649H133.956V54.748H139.039V49.6649Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1261 54.748H17.0429V59.8312H22.1261V54.748Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2092 54.748H22.1261V59.8312H27.2092V54.748Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6251 54.748H47.5419V59.8312H52.6251V54.748Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8746 54.748H62.7914V59.8312H67.8746V54.748Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2072 54.748H83.1241V59.8312H88.2072V54.748Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.457 54.748H98.3736V59.8312H103.457V54.748Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.706 54.748H113.623V59.8312H118.706V54.748Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.789 54.748H118.706V59.8312H123.789V54.748Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.873 54.748H123.789V59.8312H128.873V54.748Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1261 59.8312H17.0429V64.9144H22.1261V59.8312Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2924 59.8312H27.2092V64.9144H32.2924V59.8312Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5419 59.8312H42.4587V64.9144H47.5419V59.8312Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6251 59.8312H47.5419V64.9144H52.6251V59.8312Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9577 59.8312H67.8746V64.9144H72.9577V59.8312Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1241 59.8312H78.0409V64.9144H83.1241V59.8312Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2072 59.8312H83.1241V64.9144H88.2072V59.8312Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.54 59.8312H103.457V64.9144H108.54V59.8312Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.706 59.8312H113.623V64.9144H118.706V59.8312Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.789 59.8312H118.706V64.9144H123.789V59.8312Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1261 64.9144H17.0429V69.9975H22.1261V64.9144Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3756 64.9144H32.2924V69.9975H37.3756V64.9144Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4587 64.9144H37.3756V69.9975H42.4587L42.4587 64.9144Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7082 64.9144H52.6251V69.9975H57.7082V64.9144Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8746 64.9144H62.7914V69.9975H67.8746V64.9144Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9577 64.9144H67.8746V69.9975H72.9577V64.9144Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2072 64.9144H83.1241V69.9975H88.2072V64.9144Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3736 64.9144H93.2904V69.9975H98.3736V64.9144Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.623 64.9144H108.54V69.9975H113.623V64.9144Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.873 64.9144H123.789V69.9975H128.873V64.9144Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.039 64.9144H133.956V69.9975H139.039V64.9144Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0429 69.9975H11.9597V75.0807H17.0429V69.9975Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1261 69.9975H17.0429V75.0807H22.1261V69.9975Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2924 69.9975H27.2092V75.0807H32.2924V69.9975Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5419 69.9975H42.4587L42.4587 75.0807H47.5419V69.9975Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7082 69.9975H52.6251V75.0807H57.7082V69.9975Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8746 69.9975H62.7914V75.0807H67.8746V69.9975Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9577 69.9975H67.8746V75.0807H72.9577V69.9975Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3736 69.9975H93.2904V75.0807H98.3736V69.9975Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.457 69.9975H98.3736V75.0807H103.457V69.9975Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.54 69.9975H103.457V75.0807H108.54V69.9975Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.623 69.9975H108.54V75.0807H113.623V69.9975Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.039 69.9975H133.956V75.0807H139.039V69.9975Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0429 75.0807H11.9597V80.1639H17.0429V75.0807Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2092 75.0807H22.1261V80.1639H27.2092V75.0807Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4587 75.0807H37.3756V80.1639H42.4587L42.4587 75.0807Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6251 75.0807H47.5419V80.1639H52.6251V75.0807Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7082 75.0807H52.6251V80.1639H57.7082V75.0807Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8746 75.0807H62.7914V80.1639H67.8746V75.0807Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0409 75.0807H72.9577V80.1639H78.0409V75.0807Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1241 75.0807H78.0409V80.1639H83.1241V75.0807Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2904 75.0807H88.2073V80.1639H93.2904V75.0807Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3736 75.0807H93.2904V80.1639H98.3736V75.0807Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.54 75.0807H103.457V80.1639H108.54V75.0807Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.706 75.0807H113.623V80.1639H118.706V75.0807Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.789 75.0807H118.706V80.1639H123.789V75.0807Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.956 75.0807H128.873V80.1639H133.956V75.0807Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.039 75.0807H133.956V80.1639H139.039V75.0807Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0429 80.1639H11.9597V85.247H17.0429V80.1639Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4587 80.1639H37.3756V85.247H42.4587V80.1639Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5419 80.1639H42.4587V85.247H47.5419V80.1639Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8746 80.1639H62.7914V85.247H67.8746V80.1639Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9577 80.1639H67.8746V85.247H72.9577V80.1639Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0409 80.1639H72.9577V85.247H78.0409V80.1639Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1241 80.1639H78.0409V85.247H83.1241V80.1639Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.54 80.1639H103.457V85.247H108.54V80.1639Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.623 80.1639H108.54V85.247H113.623V80.1639Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.706 80.1639H113.623V85.247H118.706V80.1639Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.789 80.1639H118.706V85.247H123.789V80.1639Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0429 85.247H11.9597V90.3302H17.0429V85.247Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1261 85.247L17.0429 85.247V90.3302H22.1261V85.247Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2924 85.247H27.2092V90.3302H32.2924V85.247Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3756 85.247L32.2924 85.247V90.3302H37.3756V85.247Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7082 85.247H52.6251V90.3302H57.7082V85.247Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9577 85.247H67.8746V90.3302H72.9577V85.247Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2072 85.247L83.1241 85.247V90.3302H88.2072V85.247Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.54 85.247H103.457V90.3302H108.54V85.247Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.623 85.247H108.54V90.3302H113.623V85.247Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.706 85.247H113.623V90.3302H118.706V85.247Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.789 85.247H118.706V90.3302H123.789V85.247Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2924 90.3302H27.2092V95.4134H32.2924V90.3302Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3756 90.3302H32.2924V95.4134H37.3756V90.3302Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4587 90.3302H37.3756V95.4134H42.4587V90.3302Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5419 90.3302H42.4587V95.4134H47.5419V90.3302Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7082 90.3302H52.6251V95.4134H57.7082V90.3302Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7914 90.3302H57.7082V95.4134H62.7914V90.3302Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8746 90.3302H62.7914V95.4134H67.8746V90.3302Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9577 90.3302H67.8746V95.4134H72.9577V90.3302Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0409 90.3302H72.9577V95.4134H78.0409V90.3302Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2904 90.3302H88.2072L88.2073 95.4134H93.2904V90.3302Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3736 90.3302H93.2904V95.4134H98.3736V90.3302Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.457 90.3302H98.3736V95.4134H103.457V90.3302Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.54 90.3302H103.457V95.4134H108.54V90.3302Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.623 90.3302H108.54V95.4134H113.623V90.3302Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.706 90.3302H113.623V95.4134H118.706V90.3302Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.789 90.3302H118.706V95.4134H123.789V90.3302Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.039 90.3302H133.956V95.4134H139.039V90.3302Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9577 95.4134H67.8746V100.497H72.9577V95.4134Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0409 95.4134H72.9577V100.497H78.0409V95.4134Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3736 95.4134H93.2904V100.497H98.3736V95.4134Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.706 95.4134H113.623V100.497H118.706V95.4134Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.789 95.4134H118.706V100.497H123.789V95.4134Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.873 95.4134H123.789V100.497H128.873V95.4134Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0429 100.497H11.9597V105.58H17.0429V100.497Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1261 100.497H17.0429V105.58H22.1261V100.497Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2092 100.497H22.1261V105.58H27.2092V100.497Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2924 100.497H27.2092V105.58H32.2924V100.497Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3756 100.497H32.2924V105.58H37.3756V100.497Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4587 100.497H37.3756V105.58H42.4587V100.497Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5419 100.497H42.4587V105.58H47.5419V100.497Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8746 100.497H62.7914V105.58H67.8746V100.497Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0409 100.497H72.9577V105.58H78.0409V100.497Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1241 100.497H78.0409V105.58H83.1241V100.497Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2904 100.497H88.2073V105.58H93.2904V100.497Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3736 100.497H93.2904V105.58H98.3736V100.497Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.54 100.497H103.457V105.58H108.54V100.497Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.706 100.497H113.623V105.58H118.706V100.497Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.873 100.497H123.789V105.58H128.873V100.497Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0429 105.58H11.9597V110.663H17.0429V105.58Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5419 105.58H42.4587L42.4587 110.663H47.5419V105.58Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7082 105.58H52.6251V110.663H57.7082V105.58Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7914 105.58H57.7082V110.663H62.7914V105.58Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8746 105.58H62.7914V110.663H67.8746V105.58Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9577 105.58H67.8746V110.663H72.9577V105.58Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0409 105.58H72.9577V110.663H78.0409V105.58Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1241 105.58H78.0409V110.663H83.1241V105.58Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2904 105.58H88.2073V110.663H93.2904V105.58Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3736 105.58H93.2904V110.663H98.3736V105.58Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.706 105.58H113.623V110.663H118.706V105.58Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.956 105.58H128.873V110.663H133.956V105.58Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0429 110.663H11.9597V115.746H17.0429V110.663Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2092 110.663H22.1261V115.746H27.2092V110.663Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2924 110.663H27.2092V115.746H32.2924V110.663Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3756 110.663H32.2924V115.746H37.3756V110.663Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5419 110.663H42.4587V115.746H47.5419V110.663Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8746 110.663H62.7914V115.746H67.8746V110.663Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9577 110.663H67.8746V115.746H72.9577V110.663Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0409 110.663H72.9577V115.746H78.0409V110.663Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3736 110.663H93.2904V115.746H98.3736V110.663Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.457 110.663H98.3736V115.746H103.457V110.663Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.54 110.663H103.457V115.746H108.54V110.663Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.623 110.663H108.54V115.746H113.623V110.663Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.706 110.663H113.623V115.746H118.706V110.663Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.873 110.663H123.789V115.746H128.873V110.663Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.956 110.663H128.873V115.746H133.956V110.663Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0429 115.746H11.9597V120.829H17.0429V115.746Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2092 115.746H22.1261V120.829H27.2092V115.746Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2924 115.746H27.2092V120.829H32.2924V115.746Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3756 115.746H32.2924V120.829H37.3756V115.746Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5419 115.746H42.4587V120.829H47.5419V115.746Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7914 115.746H57.7082V120.829H62.7914V115.746Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0409 115.746H72.9577V120.829H78.0409V115.746Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1241 115.746H78.0409V120.829H83.1241V115.746Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2072 115.746H83.1241V120.829H88.2072V115.746Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2904 115.746H88.2072V120.829H93.2904V115.746Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3736 115.746H93.2904V120.829H98.3736V115.746Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.457 115.746H98.3736V120.829H103.457V115.746Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.623 115.746H108.54V120.829H113.623V115.746Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.706 115.746H113.623V120.829H118.706V115.746Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.789 115.746H118.706V120.829H123.789V115.746Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.956 115.746H128.873V120.829H133.956V115.746Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.039 115.746H133.956V120.829H139.039V115.746Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0429 120.829H11.9597V125.912H17.0429V120.829Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2092 120.829H22.1261V125.912H27.2092V120.829Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2924 120.829H27.2092V125.912H32.2924V120.829Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3756 120.829H32.2924V125.912H37.3756V120.829Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5419 120.829H42.4587V125.912H47.5419V120.829Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7082 120.829H52.6251V125.912H57.7082V120.829Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1241 120.829H78.0409V125.912H83.1241V120.829Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3736 120.829H93.2904V125.912H98.3736V120.829Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.706 120.829H113.623V125.912H118.706V120.829Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.789 120.829H118.706V125.912H123.789V120.829Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.039 120.829H133.956V125.912H139.039V120.829Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0429 125.912H11.9597V130.996H17.0429V125.912Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5419 125.912H42.4587V130.996H47.5419V125.912Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7914 125.912H57.7082V130.996H62.7914V125.912Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9577 125.912H67.8746V130.996H72.9577V125.912Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1241 125.912H78.0409V130.996H83.1241V125.912Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2904 125.912H88.2073V130.996H93.2904V125.912Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.457 125.912H98.3736V130.996H103.457V125.912Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.873 125.912H123.789V130.996H128.873V125.912Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0429 130.996H11.9597V136.079H17.0429V130.996Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1261 130.996H17.0429V136.079H22.1261V130.996Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2092 130.996H22.1261V136.079H27.2092V130.996Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2924 130.996H27.2092V136.079H32.2924V130.996Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3756 130.996H32.2924V136.079H37.3756V130.996Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4587 130.996H37.3756V136.079H42.4587L42.4587 130.996Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5419 130.996H42.4587L42.4587 136.079H47.5419V130.996Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7082 130.996H52.6251V136.079H57.7082V130.996Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8746 130.996H62.7914V136.079H67.8746V130.996Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9577 130.996H67.8746V136.079H72.9577V130.996Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0409 130.996H72.9577V136.079H78.0409V130.996Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2073 130.996H83.1241V136.079H88.2072L88.2073 130.996Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2904 130.996H88.2073L88.2072 136.079H93.2904V130.996Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3736 130.996H93.2904V136.079H98.3736V130.996Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.54 130.996H103.457V136.079H108.54V130.996Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.623 130.996H108.54V136.079H113.623V130.996Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.873 130.996H123.789V136.079H128.873V130.996Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.039 130.996H133.956V136.079H139.039V130.996Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_1014"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 151,
    height: 151,
    fill: "white",
    transform: "translate(-0.000671387)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCode);
export default __webpack_public_path__ + "static/media/QR Code.7450db333169ea8e097aadb76f74c873.svg";
export { ForwardRef as ReactComponent };